<template>
  <div>
    <header>
      <h1 class="title is-2">{{ title }}</h1>
      <slot name="header"></slot>
      <hr style="margin-bottom: 1em;" />
    </header>

    <main>
      <slot name="description" class="description"></slot>

      <div class="container">
        <section>
          <b-tag class="tag-elem" v-for="tag in tags" :key="tag">{{
            tag
          }}</b-tag>
        </section>

        <slot name="code-labels"></slot>
      </div>

      <hr style="margin-bottom: 1em;" />

      <h2 class="title is-3">Installation</h2>

      <slot name="installation">
        <pre
          v-highlightjs
        ><code class="javascript">npm i v-infinite-slidebar</code></pre>
        <strong>Or</strong>
        <pre
          v-highlightjs
          style="margin-top: 20px !important;"
        ><code class="javascript">yarn add v-infinite-slidebar</code></pre>
      </slot>

      <hr style="margin-bottom: 1em;" />

      <h2 class="title is-3">Usage</h2>
      <slot name="usage"> </slot>

      <hr style="margin-bottom: 1em;" />

      <h2 class="title is-3">Examples</h2>
      <slot name="example"></slot>

      <hr style="margin-bottom: 1em;" />

      <h2 class="title is-3">Props</h2>
      <slot name="props-options"></slot>
    </main>

    <footer></footer>
  </div>
</template>

<script>
export default {
  name: "DocumentationTemplate",
  props: {
    title: {
      default: "Title",
      type: String,
    },
    tags: {
      default: Array,
      type: Array,
    },
  },
};
</script>

<style lang="scss">
.tag {
  font-weight: bold;
}
.tag-elem {
  margin-right: 5px;
}
.description {
  margin-bottom: 5em;
}
.container {
  margin-bottom: 2em;
}
.hljs-string {
  color: #5597d2;
}
.hljs-attr {
  color: #e76173;
}
.hljs-name {
  color: #5bec95;
}
.code-labels {
  a {
    margin-right: 10px;
  }
  margin-top: 20px;
}
.bd-anchor-link {
  padding-right: 10px;
}
.doc-div {
  padding-bottom: 20px !important;
}
pre {
  margin-bottom: 20px;
}
.example-demo-container {
  margin-bottom: 20px;
}
.slide-container {
  margin-bottom: 20px;
}
</style>
